
import { useState, useEffect, useCallback } from 'react';
import { DateRangeOption } from '@/hooks/tasks/use-task-operations';

/**
 * Hook to manage view transitions between different date ranges
 */
export const useViewTransition = (initialDateRange: DateRangeOption = 'week') => {
  const [dateRange, setDateRange] = useState<DateRangeOption>(initialDateRange);
  const [currentDate, setCurrentDate] = useState<Date>(new Date());
  const [previousDateRange, setPreviousDateRange] = useState<DateRangeOption>(initialDateRange);
  const [isChangingView, setIsChangingView] = useState(false);

  // Handle date range changes
  useEffect(() => {
    if (dateRange !== previousDateRange) {
      console.log('Date range changed:', previousDateRange, '->', dateRange);
      setIsChangingView(true);
      setPreviousDateRange(dateRange);
      
      // After a short delay, clear the changing view flag
      const timeout = setTimeout(() => {
        setIsChangingView(false);
      }, 400);
      
      return () => clearTimeout(timeout);
    }
  }, [dateRange, previousDateRange]);

  // Custom date change handler with task reset
  const setCurrentDateAndRefresh = useCallback((date: Date) => {
    console.log('Setting current date:', date);
    setCurrentDate(date);
  }, []);

  return {
    dateRange,
    setDateRange,
    currentDate,
    setCurrentDate: setCurrentDateAndRefresh,
    isChangingView
  };
};
